module.exports = __webpack_public_path__ + "media/images/placeholder_16by9-a0b61e6ba943558b7a5a0b9a4e417512.png";